import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Card, Breadcrumb, Table, Tag } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSession } from 'app/shared/reducers/authentication';
import { APP_TIMESTAMP_FORMAT } from 'app/config/constants';
import { TextFormat } from 'react-jhipster';
import { getApprovisonnement } from './appro.reducer';
import { getEcole } from '../ecole/ecole.reducer';

export const FondDetail = (props: RouteComponentProps<{ id: string; ecoleid: string; anneeScolaireId: string }>) => {
  const dispatch = useAppDispatch();
  const Loading = useAppSelector(state => state.approvisonnement.loading);
  const anneeScolaireId = props.match.params.anneeScolaireId;
  useEffect(() => {
    dispatch(getSession);
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getApprovisonnement(props.match.params.id));
  }, []);
  const approList = useAppSelector(state => state.approvisonnement.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const { match } = props;
  const columns = [
    { title: '', dataIndex: 'label' },
    { title: '', dataIndex: 'value' },
  ];
  const data = [
    { key: '1', label: 'Montant', value: <span>{`${approList.montant} FCFA`}</span> },
    {
      key: '5',
      label: 'Date de la demande',
      value: <TextFormat type="date" value={`${approList.dateEmission}`} format={APP_TIMESTAMP_FORMAT} />,
    },
    ...(approList.dateValidation !== null
      ? [
          {
            key: '6',
            label: 'Date de validation',
            value: <TextFormat type="date" value={approList.dateValidation} format={APP_TIMESTAMP_FORMAT} />,
          },
        ]
      : []),
    {
      key: '7',
      label: 'Type Approvisonnement',
      value: (
        <span>
          {approList.typeApprovisonnement === 'COMPTE_BANCAIRE' ? (
            <Tag color="gray">COMPTE BANCAIRE</Tag>
          ) : approList.typeApprovisonnement === 'COMPTE_SCOLARITE' ? (
            <Tag color="green">COMPTE SCOLARITE</Tag>
          ) : null}
        </span>
      ),
    },
    {
      key: '8',
      label: 'Statut',
      value: (
        <span>
          {approList.statutApprovisonnement === 'ENCOURS' ? (
            <Tag color="red">En attente</Tag>
          ) : approList.statutApprovisonnement === 'VALIDE' ? (
            <Tag color="green">Validée</Tag>
          ) : (
            <Tag color="#dc3545">Rejeté</Tag>
          )}
        </span>
      ),
    },
    ...(approList.statutApprovisonnement === 'REJET'
      ? [
          {
            key: '6',
            label: 'Motif',
            value: <span>{`${approList.description}`}</span>,
          },
        ]
      : []),
  ];

  return (
    <>
      <Breadcrumb className="p-2">
        <Breadcrumb.Item>
          <Link to={`/home/${currentEcole && currentEcole.id}/${anneeScolaireId}`}>{currentEcole && currentEcole.nom}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/approvisonnements/${currentEcole && currentEcole.id}/${anneeScolaireId}`}>Approvisonnements</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`${match.url}`}>Details</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card>
        <Table sticky columns={columns} dataSource={data} pagination={false} bordered loading={Loading} />
      </Card>
    </>
  );
};
export default FondDetail;
